export const MuiDivider = (palette) => {
    return { root: { backgroundColor: palette.semantic.colorBorder } };
};
